import Card from "@mui/material/Card";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./finalisefs.css";
import swal from 'sweetalert';
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddFooters from "./footers";
import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import standalonecss from "../../myfin_v2/css/standalone.module.css"
import { Button } from "../../myfin_v2/elements/Button";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
import { addConsolSignatoryApiHandler, deleteConsolSignatoryApiHandler, editConsolSignatoryApiHandler, consolFinalizeFSFormatApiHandler, getConsolePopulateFSExportFSApiHandler, getConsolFinalizeFSApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import AddEditSignatory from "./AddEditSignatory";
import QuillReactEditor from "../../myfin_v2/components/QuillReactEditor";
import Signatory from "./Signatory";
import ExportPages from "./ExportPages";
// import "./finalisefs.css";
import sigCss from "../../myfin_v2/css/textEditor.module.css";

const FinaliseFsConsol = () => {

  const { consolID } = useParams();
  console.log("consolID", consolID);

  const units_values = [
    "whole numbers",
    "hundreds",
    "thousands",
    "lakhs",
    "crores",
    "millions",
  ];
  const decimal_values = [0, 1, 2, 3];
  const [removeNullFields, setRemoveNullFields] = useState(false);
  const [unit, setUnit] = useState("whole numbers");
  const [decimal, setDecimal] = useState(0);
 const [checkBoxList] = useState([
  { label: "Balance Sheet", value: "BS" },
  { label: "Profit & Loss", value: "PL" },
  { label: "Cashflow", value: "cashflow" },
  { label: "Cashflow Workings", value: "cashflow workings" },
  { label: "SOCIE", value: "socie" },
  { label: "Profit & Loss Notes", value: "PL notes" },
  { label: "Disclosure", value: "disclosure" },
  { label: "Disclosure Checklist", value: "disclosure checklist" },
  { label: "General Notes", value: "general notes" },
  { label: "Balance Sheet Notes", value: "BS notes" }
]);

  const [isInitialLoad, setIsInitialLoad] = useState(true);


  const breadcrumbItems = [
    { link: `/myfinV2/console-populatefs/${consolID}` },
    { label: "Finalise your Financial Statements", link: "", className: "headerLable" },
  ];

    const headerSections = [
      "Balance Sheet",
      "Statement of Profit & Loss",
      "Cashflow",
      "Statement of Change in Equity",
      "General Notes",
      "Balance Sheet Notes",
      "Profit & Loss Notes",
      "Disclosure",
    ];
  
    const [activeHeader, setActiveHeader] = useState("Balance Sheet");
  
    const [headerContent, setHeaderContent] = useState({});
  
    const footerSections = [
      "Balance Sheet",
      "Statement of Profit & Loss",
      "Cashflow",
      "Statement of Change in Equity",
      "General Notes",
      "Balance Sheet Notes",
      "Profit & Loss Notes",
      "Disclosure",
    ];
  
    const [activeFooter, setActiveFooter] = useState("Balance Sheet");
    const [footerContent, setFooterContent] = useState({});
  

  const [selectedFooters, setSelectedFooters] = useState([]);
  const [selectedExportPages, setSelectedExportPages] = useState([]);

  const [showAddEditSignatoryModal, setShowAddEditSignatoryModal] = useState(false);
  const [signatoryList, setSignatoryList] = useState([]);

  const handleUnitDecimal = (e) => {
    if (e.target.name === "unit") {
      setUnit(e.target.value);
    } else {
      setDecimal(e.target.value);
    }
  };



  const exportFS = (exportAs) => {
    const params = {
      consolID: consolID,
      fileType: exportAs,
    };

    getConsolePopulateFSExportFSApiHandler(params)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          {
            type:
              exportAs === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const fileUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;

        downloadLink.download =
          exportAs === "pdf"
            ? `FS_${consolID}.pdf`
            : `FS_${consolID}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch((error) => {
        console.error("exportFS error:", error);
      });
  };

  const [formData, setFormData] = useState({
    "_id": null,
    "category": null,
    "firmName": null,
    "firmRole": null,
    "firmNumber": null,
    "auditorName": null,
    "auditorRole": null,
    "membershipNumber": null,

    "directorName": null,
    "directorRole": null,
    "directorNumber": null,

    "place": null,
    "date": null
  })


useEffect(() => {

  if (isInitialLoad) return;

  handleFSFormat();

}, [ unit, decimal, selectedFooters, selectedExportPages, headerContent, footerContent]);


  useEffect(() => {
    getFinalizeFS();
  }, [])

 const getFinalizeFS = () => {
  getConsolFinalizeFSApiHandler(consolID)
    .then(response => {

      const finalizeFSFormat = response.data.finalizeFSFormat;
      const signatoryList = response.data.signatoryList;

      setUnit(finalizeFSFormat?.units ?? "whole numbers");
      setDecimal(finalizeFSFormat?.decimals ?? 0);
      setSelectedFooters(finalizeFSFormat?.addFooterTo ?? []);
      setSelectedExportPages(finalizeFSFormat?.exportPages ?? []);
      setRemoveNullFields(finalizeFSFormat?.removeNullField ?? false);
      setSignatoryList(signatoryList ?? []);
      setHeaderContent({
        "Balance Sheet": finalizeFSFormat?.BSHeader ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLHeader ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesHeader ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesHeader ?? "",
        "Cashflow": finalizeFSFormat?.cashflowHeader ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieHeader ?? "",
        "Disclosure": finalizeFSFormat?.disclosureHeader ?? "",
        "General Notes": finalizeFSFormat?.generalNotesHeader ?? "",
      });

      setFooterContent({
        "Balance Sheet": finalizeFSFormat?.BSFooter ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLFooter ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesFooter ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesFooter ?? "",
        "Cashflow": finalizeFSFormat?.cashflowFooter ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieFooter ?? "",
        "Disclosure": finalizeFSFormat?.disclosureFooter ?? "",
        "General Notes": finalizeFSFormat?.generalNotesFooter ?? "",
      });
      setIsInitialLoad(false);
    })
    .catch(error => {
      swal("Error", "Error: Get Finalize FS API Failed!", "error");
    });
};

const handleFSFormat = () => {

  const finalizeFSFormat = {
    units: unit || "whole numbers",
    decimals: typeof decimal === "number" ? decimal : 0,
    exportPages: Array.isArray(selectedExportPages) ? selectedExportPages : [],
    addFooterTo: Array.isArray(selectedFooters) ? selectedFooters : [],
    removeNullField: Boolean(removeNullFields),
  };

  const addIfFilled = (key, value) => {
    if (value && value.trim() !== "") {
      finalizeFSFormat[key] = value;
    }
  };

  addIfFilled("BSHeader", headerContent["Balance Sheet"]);
  addIfFilled("PLHeader", headerContent["Statement of Profit & Loss"]);
  addIfFilled("BSNotesHeader", headerContent["Balance Sheet Notes"]);
  addIfFilled("PLNotesHeader", headerContent["Profit & Loss Notes"]);
  addIfFilled("cashflowHeader", headerContent["Cashflow"]);
  addIfFilled("socieHeader", headerContent["Statement of Change in Equity"]);
  addIfFilled("disclosureHeader", headerContent["Disclosure"]);

  addIfFilled("BSFooter", footerContent["Balance Sheet"]);
  addIfFilled("PLFooter", footerContent["Statement of Profit & Loss"]);
  addIfFilled("BSNotesFooter", footerContent["Balance Sheet Notes"]);
  addIfFilled("PLNotesFooter", footerContent["Profit & Loss Notes"]);
  addIfFilled("cashflowFooter", footerContent["Cashflow"]);
  addIfFilled("socieFooter", footerContent["Statement of Change in Equity"]);
  addIfFilled("disclosureFooter", footerContent["Disclosure"]);

  consolFinalizeFSFormatApiHandler(
    { consolID: consolID },
    { finalizeFSFormat }
  )
    .then((response) => {
      if (!response?.data?.success) {
        swal(
          "Error",
          response?.data?.error || "Unable to update Finalise FS format",
          "error"
        );
      }
    })
    .catch((error) => {
      swal(
        "Error",
        error?.response?.data?.error || "Unable to update Finalise FS format",
        "error"
      );
    });
};




  useEffect(() => {
    if (showAddEditSignatoryModal === false) {
      setFormData({
        "_id": null,
        "category": null,
        "firmName": null,
        "firmRole": null,
        "firmNumber": null,
        "auditorName": null,
        "auditorRole": null,
        "membershipNumber": null,

        "directorName": null,
        "directorRole": null,
        "directorNumber": null,

        "place": null,
        "date": null
      })
    }
  }, [showAddEditSignatoryModal])


  const handleSaveAuditor = (formData) => {

    const payload = {
      category: formData.category,
      place: formData.place,
      date: formData.date,

      ...(formData.category === "auditor" && {
        firmName: formData.firmName,
        firmRole: formData.firmRole,
        firmNumber: formData.firmNumber,
        auditorName: formData.auditorName,
        auditorRole: formData.auditorRole,
        membershipNumber: formData.membershipNumber,
      }),

      ...(formData.category === "board of directors" && {
        directorName: formData.directorName,
        directorRole: formData.directorRole,
        directorNumber: formData.directorNumber,
      }),
    };

    if (formData?._id) {
      saveModifiedSignatoryHandler(payload, formData?._id);
    } else {
      addSignatoryHandler(payload);
    }

  }

  const addSignatoryHandler = (payload) => {

    addConsolSignatoryApiHandler({ consolID: consolID }, payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory added successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to add Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to add Signatory",
          "error"
        );
      });
  }

  const saveModifiedSignatoryHandler = (payload, signId) => {

    editConsolSignatoryApiHandler({ consolID: consolID, signatoryID: signId }, payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory updated successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update Signatory",
          "error"
        );
      });
  }

  const handleDeleteSignatory = (signId) => {
    swal({
      title: "Confirm deletion of Signatory",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteConsolSignatoryApiHandler({ consolID: consolID, signatoryID: signId })
          .then((response) => {
            if (response?.data?.success === true) {
              swal("Signatory deleted successfully", "", "success");
              getFinalizeFS();
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to deleted Signatory",
                "error"
              );
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to deleted Signatory",
              "error"
            );
          });
      }
    });
  }


  const editSignatory = (signId) => {
    const modifySignatory = signatoryList.find((sign) => sign._id === signId)
    console.log("modifySignatory", modifySignatory);

    setFormData({
      "_id": modifySignatory?._id ?? null,
      "category": modifySignatory?.category ?? null,
      "firmName": modifySignatory?.firmName ?? null,
      "firmRole": modifySignatory?.firmRole ?? null,
      "firmNumber": modifySignatory?.firmNumber ?? null,
      "auditorName": modifySignatory?.auditorName ?? null,
      "auditorRole": modifySignatory?.auditorRole ?? null,
      "membershipNumber": modifySignatory?.membershipNumber ?? null,

      "directorName": modifySignatory?.directorName ?? null,
      "directorRole": modifySignatory?.directorRole ?? null,
      "directorNumber": modifySignatory?.directorNumber ?? null,

      "place": modifySignatory?.place ?? null,
      "date": modifySignatory?.date ?? null
    })
    setShowAddEditSignatoryModal(true);
  }

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
            {/* <BookcluosureNav bookClosureId={bookClosureId} setCreatePackageModal={setCreatePackageModal} setSavePresetModal={setSavePresetModal} selectedEntries={selectedEntries} entries={entries} /> */}
            <div className="fscp-header">
              <Breadcrumb style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as Excel"
                onClick={() => { exportFS("excel") }}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as PDF"
                onClick={() => { exportFS("pdf") }}
              />
            </div>

            <div className="mx-3">
              <div className={standalonecss.finaliseFSDiv}
              >
                <div className="d-flex mt-4 ml-3" style={{ gap: "105px", justifyContent: "space-between", alignItems: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "210px",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel
                        id="unit-value-select-label"
                        shrink={unit !== null && unit !== undefined && unit !== ""}
                        sx={{
                          "&.Mui-focused": { color: "#B3C0BD" },
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#B3C0BD",
                          top: "-5px"
                        }}
                      >
                        {/* Units */}
                      </InputLabel>

                      <Select
                        labelId="unit-value-select-label"
                        id="unit-value-select"
                        value={unit}
                        name="unit"
                        onChange={handleUnitDecimal}
                        input={<OutlinedInput />}
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          width: "300px",
                          height: "40px",
                          backgroundColor: "#F4FAF5",
                          borderRadius: "10px",
                          fontSize: "14px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                        }}
                        MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                            mt: 1,
                          },
                        },
                      }}

                      >
                        {units_values.map((item, key) => (
                          <MenuItem value={item} key={key} 
                          sx={{
                          "&:hover": {
                            backgroundColor: "#F4FAF5",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#C2E6D1",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#C2E6D1",
                          },
                        }}
                         >
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "250px",
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel
                          id="decimal-value-select-label"
                          shrink={decimal !== null && decimal !== undefined && decimal !== ""}
                          sx={{
                            "&.Mui-focused": { color: "#B3C0BD" },
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#B3C0BD",
                            top: "-5px"
                          }}
                        >
                          {/* Decimals */}
                        </InputLabel>

                        <Select
                          labelId="decimal-value-select-label"
                          id="decimal-value-select"
                          value={decimal}
                          name="decimal"
                          onChange={handleUnitDecimal}
                          input={<OutlinedInput  />}
                          IconComponent={ExpandMoreIcon}
                          sx={{
                            width: "300px",
                            height: "40px",
                            backgroundColor: "#F4FAF5",
                            borderRadius: "10px",
                            fontSize: "14px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: "#ffffff",
                                borderRadius: "4px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                                mt: 1,
                              },
                            },
                          }}

                        >
                          {decimal_values.map((item, key) => (
                            <MenuItem value={item} key={key} 
                            sx={{
                            "&:hover": {
                              backgroundColor: "#F4FAF5",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#C2E6D1",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "#C2E6D1",
                            },
                          }}
                           >
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      paddingRight: "30px",
                      cursor: "pointer",
                      marginLeft: "auto",
                    }}
                    onClick={() => setRemoveNullFields(!removeNullFields)}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "16px",
                        borderRadius: "20px",
                        backgroundColor: removeNullFields ? "#2D8861" : "#CCD5D3",
                        position: "relative",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          backgroundColor: "white",
                          position: "absolute",
                          top: "0px",
                          left: removeNullFields ? "18px" : "0px",
                          transition: "all 0.3s ease",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#205A46",
                      }}
                    >
                      Remove Null Fields
                    </span>

                  </div>
                </div>

                <div className="p-3">
                   <Card className="pb-10" style={{ borderRadius: "10px", border: "1px solid #CCD5D3", marginBottom: "20px"}}>
                <div className={standalonecss.finaliseFSSecHeader}>
                  <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>
                    HEADER
                  </span>
                </div>

                <div className={sigCss.headerWrapper}>
                  
                  <div className={sigCss.leftHeaderContainer}>
                    {headerSections.map((item) => (
                      <div
                        key={item}
                        onClick={() => setActiveHeader(item)}
                        className={`${sigCss.headerItem} ${
                          activeHeader === item ? sigCss.activeHeaderItem : ""
                        }`}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                 <div
                className={sigCss.rightHeaderEditor}
                style={{ height: "100px" }}
              >
                <div style={{ flex: 1 }}>
                  <QuillReactEditor
                    greyToolbar={true}
                    value={headerContent[activeHeader] || ""}
                    onChange={(data) =>
                      setHeaderContent((prev) => ({
                        ...prev,
                        [activeHeader]: data.html,
                      }))
                    }
                  />
                </div>
              </div>
             </div>
            </Card>

          <Card className="pb-2" style={{ borderRadius: "10px",  border: "1px solid #CCD5D3", marginBottom: "20px"}} >
            <div className={standalonecss.finaliseFSSecHeader}>
              <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>FOOTER</span>
            </div>

              <div className={sigCss.headerWrapper}>
                <div className={sigCss.leftHeaderContainer}>
                  {footerSections.map((item) => (
                    <div
                      key={item}
                      onClick={() => setActiveFooter(item)}
                      className={`${sigCss.headerItem} ${
                        activeFooter === item ? sigCss.activeHeaderItem : ""
                      }`}
                    >
                      {item}
                    </div>
                  ))}
                </div>

                <div
                  className={sigCss.rightHeaderEditor}
                  style={{ height: "100px" }} >
                  <QuillReactEditor
                    greyToolbar={true}
                    value={footerContent[activeFooter] || ""}
                    onChange={(data) =>
                      setFooterContent((prev) => ({
                        ...prev,
                        [activeFooter]: data.html,
                      }))
                    }
                  />
                </div>

              </div>
            </Card>
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>SIGNATORY</span>
                    </div>
                    <AddFooters
                      checkBoxList={checkBoxList}
                      selectedItems={selectedFooters}
                      setSelectedItems={setSelectedFooters}
                    />
                    {/* <div className={`${commoncss.clickable} ml-3 my-2`} style={{ borderRadius: "6px", border: "1px solid #A0DABC"}} onClick={() => { setShowAddEditSignatoryModal(true) }}>
                      <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signatory</span>
                    </div> */}
                    <div style={{ display: "grid",  gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "50px",  padding: "20px" }}
                    // style={{ "height": "42vh", "overflow": "auto" }}
                    >
                      {signatoryList.map((signatory) => (
                        <>
                          <Signatory key={signatory._id} signatory={signatory} editSignatory={editSignatory} handleDeleteSignatory={handleDeleteSignatory} />
                        </>
                      ))}
                    <div onClick={() => setShowAddEditSignatoryModal(true)} className={sigCss.addSignatoryCard} >
                      Add New <br /> Signatory
                    </div>
                    </div>
                    {/* <div className={`${commoncss.clickable} ml-3 my-2`} onClick={() => { setShowAddEditSignatoryModal(true) }}>
                      <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signatory</span>
                    </div> */}
                  </Card>

                  <Card className="pb-2 mt-3" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>EXPORT PAGES</span>
                    </div>
                    <ExportPages
                      checkBoxList={checkBoxList}
                      selectedItems={selectedExportPages}
                      setSelectedItems={setSelectedExportPages}
                    />
                  </Card>
                </div>
              </div>
            </div>
            {showAddEditSignatoryModal && <AddEditSignatory setShowAddEditSignatoryModal={setShowAddEditSignatoryModal} formData={formData} setFormData={setFormData} onSave={handleSaveAuditor} />}
          </motion.div>
        </div >
      </div >
    </>
  );
};

export default FinaliseFsConsol;
